import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { path: '/', label: 'Accueil' },
  { path: '/mariage', label: 'Le mariage' },
  { path: '/hebergement', label: 'Hébergement' },
  { path: '/logistique', label: 'Logistique' },
  { path: '/galerie', label: 'Galerie' },
  { path: '/cadeaux', label: 'Cadeaux' },
  { path: '/rsvp', label: 'RSVP', isHighlighted: true },
];

export const Navigation = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <nav 
      className="fixed top-0 w-full z-50 bg-[#fcf6f1] border-b border-[#e8ddd4]"
      data-testid="main-navigation"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo with Orange 3 and G & C text */}
          <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_4ebaa9cc-440b-4527-9761-4d4c07f094d6/artifacts/ok3lmo58_Orange%203.png"
              alt="Orange decoration"
              className="h-10 w-auto"
            />
            <span className="font-display text-3xl tracking-wide text-[#8d5f3f] font-medium">G & C</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              item.isHighlighted ? (
                <Link
                  key={item.path}
                  to={item.path}
                  className="px-6 py-2.5 rounded-full bg-[#e17c3b] text-white text-sm tracking-wider uppercase transition-all duration-300 hover:bg-[#c96a2f] hover:scale-105 shadow-md font-medium"
                  data-testid={`nav-link-${item.label.toLowerCase()}`}
                >
                  {item.label}
                </Link>
              ) : (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-sm tracking-wider uppercase transition-colors duration-300 hover:text-[#e17c3b] ${
                    location.pathname === item.path 
                      ? 'text-[#e17c3b] font-medium' 
                      : 'text-[#8d5f3f]'
                  }`}
                  data-testid={`nav-link-${item.label.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {item.label}
                </Link>
              )
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden px-4 py-2 text-[#8d5f3f] text-sm tracking-wider uppercase font-medium hover:text-[#e17c3b] transition-colors"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? 'Fermer' : 'Menu'}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div 
          className="lg:hidden absolute top-20 left-0 right-0 bg-[#fcf6f1] border-b border-[#e8ddd4] shadow-lg"
          data-testid="mobile-menu"
        >
          <div className="flex flex-col py-4">
            {navItems.map((item) => (
              item.isHighlighted ? (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className="mx-4 my-2 px-6 py-3 rounded-full bg-[#e17c3b] text-white text-sm tracking-wider uppercase text-center transition-all duration-300 hover:bg-[#c96a2f] font-medium"
                  data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                >
                  {item.label}
                </Link>
              ) : (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-6 py-3 text-sm tracking-wider uppercase transition-colors duration-300 hover:bg-[#f5ebe3] ${
                    location.pathname === item.path 
                      ? 'text-[#e17c3b] font-medium bg-[#f5ebe3]' 
                      : 'text-[#8d5f3f]'
                  }`}
                  data-testid={`mobile-nav-link-${item.label.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {item.label}
                </Link>
              )
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};
